import DatePicker from 'react-datepicker';
import '../../styles/DatePicker.css';

/**
 * ClearableDatePicker
 *
 * Props:
 * - selected: Date // current selected date
 * - onChange: (date) => void // callback when date changes
 * - onClear?: () => void // callback when clear button is clicked
 * - placeholder?: string // placeholder text
 * - className?: string // additional CSS classes for the wrapper
 * - dateFormat?: string // date format (default: "dd/MM/yyyy")
 * - disabled?: boolean // whether datepicker is disabled
 * - ...props // any other DatePicker props
 */
export default function ClearableDatePicker({
  selected,
  onChange,
  onClear,
  placeholder = "Select date",
  className = "",
  dateFormat = "dd/MM/yyyy",
  disabled = false,
  ...props
}) {
  const hasValue = selected !== null && selected !== undefined;

  const handleClear = () => {
    onClear?.();
  };

  return (
    <div className={`relative ${className}`}>
      <DatePicker
        selected={selected}
        onChange={onChange}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        disabled={disabled}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        wrapperClassName="w-full"
        calendarClassName="themed-datepicker-calendar"
        popperClassName="themed-datepicker-popper"
        popperProps={{
          strategy: "fixed",
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                boundary: "viewport",
                altBoundary: true,
                padding: 8
              }
            },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["bottom", "top", "bottom-start", "top-start"]
              }
            }
          ]
        }}
        {...props}
      />
      {/* Clear button - same style as dropdown and input */}
      {hasValue && !disabled && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
          title="Clear date"
        >
          <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
}